import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';


export interface DeviationRequestParam {
    pickNumber: number;
    deviation: number;
}

@Injectable()
export class DeviationService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }

    // get deviation

    getAllDeviationData(pageNumber: any, limit: any): Observable<any> {
        const me = this;
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        return me.apiRequest.get(this.appConfig.deviation_url, params);
    }


}
